import { render, staticRenderFns } from "./modal.component.vue?vue&type=template&id=68ae24c5"
import script from "./modal.component.ts?vue&type=script&lang=ts&external"
export * from "./modal.component.ts?vue&type=script&lang=ts&external"
import style0 from "./modal.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports